import {
  ARTICLE_PAGE_SCHEMA,
  getBreadCrumbSchema,
} from '../../../constants/componentStaticData';
import { domainCode } from '../../../constants/staticPageConstants';
import { Meta } from '../../../layout/Meta';
import { handleTrack } from '../../../utils/tracker';
import { Breadcrumb } from '../../Atoms/BreadCrumb';
import { ScrollTopButton } from '../../glossary/components/ScrollTopButton';
import { ChevronRight } from '../../Icons/rightArrow/ChevronRight';
import { GLOSSARY_LIST_SCHEMA, GLOSSARY_SCHEMA } from '../utils/contants';
import { TListCardProps } from '../utils/types';
import { transformBreadcrumbKeyword } from '../utils/utils';
import { KeywordGrid } from './KeywordGrid';
import { Search } from './Search';
import { Trending } from './Trending';

const GlossaryIndex = ({
  domain,
  queryParam,
  data,
}: {
  domain?: string;
  queryParam: string;
  data?: TListCardProps[];
}): JSX.Element => {
  const handleEvent = (e: React.MouseEvent | React.TouchEvent) => {
    handleTrack({
      label: 'index_keyword',
      obj: e.target,
    });
  };
  const BREADCRUMB_DATA = [
    { title: 'Home', link: '/glossary' },
    {
      title: `${queryParam?.toUpperCase()}`,
      link: `/glossary/${queryParam?.toUpperCase()}/index/`,
    },
  ];

  return (
    <>
      <Meta
        title={`The FinTech terms beginning with ${queryParam?.toUpperCase()} - ClearTax`}
        description="FinTech Glossary is a complete financial guide to understanding the FinTech terms like taxation, personal finance, investments, trading, economy, and more."
        canonical={`https://${domain}/glossary/${queryParam?.toUpperCase()}/index`}
      />
      <div className="wg-container py-12 mx-auto sm:py-2">
        <Breadcrumb dataSet={transformBreadcrumbKeyword(queryParam)} />
        <Search domainVal={domainCode.cleartaxIn} />
        <Trending domainVal={domainCode.cleartaxIn} />
        <KeywordGrid />
        <ScrollTopButton />
        <div className="mb-20 mt-12">
          <h2 className="text-s-40 font-bold mb-6">
            {queryParam?.toUpperCase()}
          </h2>
          <ul
            className="grid grid-cols-3 sm:grid-cols-1 gap-x-10 gap-y-3"
            onClick={handleEvent}
          >
            {data?.map((term) => {
              return (
                <li key={term.title}>
                  <a
                    href={`/glossary/${term.permalink}`}
                    className="text-grey-970 hover:text-blue-350 pr-2 flex justify-between"
                  >
                    <span>{term.title}</span>
                    <span className="flex-shrink-0">
                      <ChevronRight color={'#9092A3'} />
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <KeywordGrid />
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            ARTICLE_PAGE_SCHEMA({
              title: GLOSSARY_LIST_SCHEMA(queryParam).title,
              url: GLOSSARY_LIST_SCHEMA(queryParam).url,
              productType: GLOSSARY_LIST_SCHEMA(queryParam).productType,
              metaDesc: GLOSSARY_SCHEMA.metaDesc,
              datePublished: GLOSSARY_SCHEMA.datePublished,
              dateModified: GLOSSARY_SCHEMA.dateModified,
              logoUrl: GLOSSARY_SCHEMA.logoUrl,
            })
          ),
        }}
      ></script>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB_DATA)),
        }}
      ></script>
    </>
  );
};

export default GlossaryIndex;
